import { useCallback } from "react";

import type {
  TUseCounterInputOptions,
} from "@/ui/components/form/CounterInput/CounterInput.config";

export const useCounterInput = ({
  value,
  min,
  max,
  step,
  disabled,
  onChange,
}: TUseCounterInputOptions) => {
  const changeValue = useCallback((amount: number) => {
    const nextValue = value + amount;
    const boundedValue = Math.max(min, max === undefined ? nextValue : Math.min(nextValue, max));

    onChange(boundedValue);
  }, [ max, min, onChange, value ]);

  return {
    decrementDisabled: disabled || value <= min,
    incrementDisabled: disabled || (max !== undefined && value >= max),
    decrement: () => changeValue(-step),
    increment: () => changeValue(step),
  };
};
